import React from 'react';

import { DesignerSummary } from '../../../../../../../components/DesignerProfile';

const SummaryComponent = ({ designer, refetch, onSubmit }) => {
  return <DesignerSummary designer={designer} refetch={refetch} onSubmit={onSubmit} />;
};

export default SummaryComponent;
